






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetOssParams } from "@/request/model";
import * as OSS from "ali-oss";
import Shetujibing from "./types/shetujibing.vue";
import Shetufuzhu from "./types/shetufuzhu.vue";
import Chihengfenlei from "./types/chihengfenlei.vue";
import Shetaihoubao from "./types/shetaihoubao.vue";
import Jibingfuzhu from "./types/jibingfuzhu.vue";
import JibingChufang from "./types/jibingchufang.vue";
import Zhengzhuangtishi from "./types/zhengzhuangtishi.vue";
import Tizhibianshi from "./types/tizhibianshi.vue";
@Component({
  components: {
    Shetujibing,
    Shetufuzhu,
    Chihengfenlei,
    Shetaihoubao,
    Jibingfuzhu,
    JibingChufang,
    Zhengzhuangtishi,
    Tizhibianshi
  }
})
export default class ModelTrialTypeTransfer extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private message: any;
  private ossReady: boolean = false;
  private messageChange(message) {
    this.$emit("update:message", message);
  }
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  @Watch("model.type", { immediate: true })
  private modelTypeChange(type) {
    const typeArr: any[] = [
      "舌图疾病筛查模型",
      "舌图辅助辨证模型",
      "齿痕分类模型",
      "舌苔厚薄分类模型"
    ];
    // if (typeArr.includes(this.model.type)) {
    //   if (!this.ossClient.options) {
    //     this.createOss().then(() => {
    //       this.ossReady = true;
    //     });
    //   } else {
    //     this.ossReady = true;
    //   }
    // }
  }
  /**
   * @description 创建oss
   */
  private createOss() {
    return new Promise((resolve, reject) => {
      GetOssParams(this).then((data: any) => {
        const client = new OSS({
          accessKeyId: data.Credentials.AccessKeyId,
          accessKeySecret: data.Credentials.AccessKeySecret,
          stsToken: data.Credentials.SecurityToken,
          endpoint: data.endpoint,
          bucket: data.bucket
        });
        this.$store.commit("updateOss", client);
        resolve();
      });
    });
  }
  /**
   * @description 开始分析
   */
  private start() {
    this.$emit("start");
  }
}
